/*eslint-disable*/
import router from '../../router'
// import axios from 'axios'
import { AppUrl, guest_api as axios } from '@/assets/js/variables'
import VueCookies from 'vue-cookies'
import JwtService from '../../assets/js/JwtService'

const state = {
  authtoken: VueCookies.get('authtoken'),
  isLoading: false,
  token_check: undefined,
}

const getters = {

}

const actions = {
  getUser ({ commit }, credentials) {
    // axios.defaults.withCredentials = true
    const params = new URLSearchParams();
    params.append('username', credentials.username)
    params.append('password', credentials.password)
    params.append('grant_type', 'password')
    params.append('task', 'login')
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, params)
        .then(response => {
          if (response.data.loggedIn) {
            const token = response.data.Authorization.access_token
            commit('SET_userLogin', token)
            VueCookies.set('authtoken', token, '1d')
            commit('SET_AUTHTOKEN', token)
            console.log('JWT', token, response.data.Authorization.expires_in);
            JwtService.saveToken(token, response.data.Authorization.expires_in)
            // setAuthHeader(response.data.payload.token)
            resolve(1)
          } else {
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  signOut ({commit}) {
    commit('logout')
    router.replace('/login')
  },
}

const mutations = {
  SET_userLogin (state, token) {
    state.authtoken = token
  },
  SET_loading (state, bool) {
    state.isLoading = bool
  },
  SET_AUTHTOKEN (state, id) {
    state.authtoken = id
    // JwtService.saveToken()
  },
  logout (state) {
    console.log('logout')
    this.commit('authModule/CLEAR_CHECK')
    state.authtoken = null
    VueCookies.remove('authtoken');
    JwtService.destroyToken();
  },
  SET_CHECK(state) {
    const that = this;
    state.token_check = setInterval(function () {
      that.commit('authModule/check_expiration')
    }(), 300000);
  },
  CLEAR_CHECK( state ) {
    clearInterval(state.token_check)
  },
  check_expiration() {
    const is_active = JwtService.isActiveToken();
    console.log('active token', is_active)
    if (!is_active) {
      this.commit('authModule/logout')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js